module.exports = __webpack_public_path__ + "static/media/close-outline.73b32de4.svg";